import type {RequestFilter} from './types';

export const addExternalAccountFilter: RequestFilter = {
  matchers: [
    {
      urlPath: /\/v1\/account/,
      method: 'POST',
      body: /external_account=/,
    },
    {
      urlPath: /\/v1\/account/,
      method: 'POST',
      body: /(external_account%5B\w+%5D=\w+&?)+&(default_currency=\w+)/,
    },
    {
      urlPath: /\/v1\/account/,
      method: 'POST',
      body: /(external_account%5Bfinancial_account%5D=)/,
    },
    {
      urlPath: /\/v1\/account/,
      method: 'POST',
      body: /(external_account.*%5Bobject%5D=blockchain_address)/,
    },
    {
      urlPath: /\/v1\/accounts\/\w+\/external_accounts/,
      method: 'POST',
    },
    {
      urlPath: /\/v1\/accounts\/\w+\/external_accounts\/\w+/,
      method: 'POST',
    },
    {
      urlPath: /\/v1\/accounts\/\w+\/external_accounts\/\w+/,
      method: 'DELETE',
    },
  ],

  filterRequest: (request) => {
    return {...request, keyType: 'external_account'};
  },
};
